import { getPlanFeatures } from '../services/SubscriptionService';

/**
 * Whether to apply the WriteForm watermark on PDF export.
 * Prefer backend exportEntitlements; fall back to plan features.
 *
 * @param {object | null | undefined} exportEntitlements
 * @param {string} [planName='essentials']
 * @returns {boolean}
 */
export function shouldApplyExportWatermark(exportEntitlements, planName = 'essentials') {
	if (exportEntitlements && typeof exportEntitlements.shouldApplyWatermark === 'boolean') {
		return exportEntitlements.shouldApplyWatermark;
	}

	const planHasWatermark = getPlanFeatures(planName)?.hasWatermark ?? true;
	if (!planHasWatermark) return false;

	if (exportEntitlements && typeof exportEntitlements.hasWatermarkRemoval === 'boolean') {
		return !exportEntitlements.hasWatermarkRemoval;
	}

	return planHasWatermark;
}
